import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { AssigneeDropdown } from './AssigneeDropdown';
import { useAssigneesField } from './useAssigneesField';
import { LinkField } from '../LinkField';
export function AssigneesField() {
    const [isOpen, setOpen] = useState(false);
    const { removeAllAssignees, selectedAssignees } = useAssigneesField();
    const formatUsers = () => {
        const assigneeLength = selectedAssignees.length;
        const [assignee] = selectedAssignees;
        const firstName = (assignee === null || assignee === void 0 ? void 0 : assignee.name) || '';
        const zero = t({ message: 'Assign users', comment: 'Assignees added to task' });
        const one = firstName;
        const other = `${firstName} +${assigneeLength - 1}`;
        if (assigneeLength === 0) {
            return zero;
        }
        if (assigneeLength === 1) {
            return one;
        }
        return other;
    };
    const linkText = formatUsers();
    return (<Menu.Root open={isOpen} onClose={() => setOpen(false)} target={<LinkField name="taskAssignees" icon={<Falcon icon="user"/>} linkText={linkText} linkPrefix={t({
                message: 'Assigned to',
                comment: 'add assignee link text when selected users',
            })} onRemove={removeAllAssignees} onClick={() => setOpen(!isOpen)}/>}>
      <AssigneeDropdown />
    </Menu.Root>);
}
